module.exports = __webpack_public_path__ + "static/media/logo.cad71bc7.png";